var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageCrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.95 9.95001C16.05 9.95001 16.95 9.05001 16.95 7.95001C16.95 6.85001 16.05 5.95001 14.95 5.95001C13.85 5.95001 12.95 6.85001 12.95 7.95001C12.95 9.05001 13.85 9.95001 14.95 9.95001Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.95 19.2H20.7V5.95001C20.7 4.44001 19.47 3.20001 17.95 3.20001H4.70001V1.95001C4.70001 1.54001 4.36001 1.20001 3.95001 1.20001C3.54001 1.20001 3.20001 1.54001 3.20001 1.95001V3.20001H1.95001C1.54001 3.20001 1.20001 3.54001 1.20001 3.95001C1.20001 4.36001 1.54001 4.70001 1.95001 4.70001H3.20001V18.03C3.20001 18.55 3.36001 19.05 3.64001 19.45C3.73001 19.58 3.83001 19.71 3.95001 19.83C4.44001 20.37 5.16001 20.7 5.95001 20.7H19.2V21.95C19.2 22.37 19.54 22.7 19.95 22.7C20.36 22.7 20.7 22.37 20.7 21.95V20.7H21.95C22.36 20.7 22.7 20.37 22.7 19.95C22.7 19.53 22.36 19.2 21.95 19.2ZM19.2 14.2L17.66 12.66C17.27 12.27 16.63 12.27 16.24 12.66L13.95 14.95L8.66001 9.66001C8.27001 9.27001 7.63001 9.27001 7.24001 9.66001L4.70001 12.2V4.70001H17.95C18.64 4.70001 19.2 5.26001 19.2 5.95001V14.2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageCrop);
export default __webpack_public_path__ + "static/media/image-crop.b1d3a1f0d02e16128a8dfa3877380097.svg";
export { ForwardRef as ReactComponent };